import styled from "styled-components";

export const LayoutStyle=styled.div`

    html, body {
    height: 100%;
    margin: 0;
    }
    .main-box{
        height:100%;
        display:flex;
        flex-direction:column;   
    }

    .second-box{
        display:flex;
        flex:1;
    }

    
    
    
    .children-box{
        flex:1;
        width:100%;
        display:flex;
        position:relative;
        margin-top:10vh;
        overflow-y:auto;
        @media only screen and (max-width: 768px){
            margin-left:0px;
        }
    }
`

